<top-navig [displayLogo]="false" title="Inscription"></top-navig>
<div class="div-bag"></div>
<div class="omber"></div>
<div class="signupContent" [class.mp-97]="ourApp">
    <div class="text-center logo">
        <img src="assets/images/logo2.png" alt="logo" width="170px">
    </div>
    <form class="login100-form validate-form">
        <div class="wrap-input100 validate-input">
            <input class="input100" type="text" [(ngModel)]="customer.lastname" name="lastname" placeholder="Nom">
            <span class="focus-input100"></span>
            <span class="symbol-input100">
                <i class="glyphicon glyphicon-arrow-right"></i>
            </span>
        </div>
        <div class="wrap-input100 validate-input">
            <input class="input100" type="text" [(ngModel)]="customer.phone" name="phone" placeholder="Téléphone">
            <span class="focus-input100"></span>
            <span class="symbol-input100">
                <i class="glyphicon glyphicon-arrow-right"></i>
            </span>
        </div>
        <div class="wrap-input100 validate-input">
            <input class="input100" type="text" [(ngModel)]="customer.email" name="email" placeholder="Email">
            <span class="focus-input100"></span>
            <span class="symbol-input100">
                <i class="glyphicon glyphicon-arrow-right"></i>
            </span>
        </div>
        <div class="wrap-input100 validate-input">
            <input class="input100" type="password" [(ngModel)]="customer.password" spellcheck=false name="pass"
                placeholder="Mot de Passe">
            <span class="focus-input100"></span>
            <span class="symbol-input100">
                <i class="glyphicon glyphicon-arrow-right"></i>
            </span>
        </div>
        <div class="wrap-input100 validate-input">
            <input class="input100" type="password" [(ngModel)]="customer.confirmePassword" spellcheck=false name="confirmePassword"
                placeholder="Confirmer votre mot de passe">
            <span class="focus-input100"></span>
            <span class="symbol-input100">
                <i class="glyphicon glyphicon-arrow-right"></i>
            </span>
        </div>


        <div class="container-login100-form-btn">
            <button class="login100-form-btn" (click)="signup()" [disabled]="loader">
                <ng-container *ngIf="loader"><i class='glyphicon glyphicon-refresh spinning'></i>&nbsp;&nbsp;</ng-container>
                S'inscrir
            </button>
        </div>
        <div class="footer">
            <table width="100%">
                <tr>
                    <td></td>
                    <td class="a1">
                        <button routerLink="../connexion" class="login-btn">
                            Se connecter &nbsp;&nbsp;
                            <i class="glyphicon glyphicon-arrow-right"></i>
                        </button>
                    </td>
                </tr>
            </table>
        </div>
        <ng-container>
            <div class="form-group">
                <p>Aprés l'inscription, merci de consulter votre boite email pour valider votre
                    inscription.
                </p>
            </div>
        </ng-container>
    </form>
</div>